export default "__VITE_ASSET__9d5ca145__"